// extracted by mini-css-extract-plugin
export default {"title":"AddressController_title__A7mQ0"};